import type { ConnectionState, LobbySnapshot } from './types';

export interface AppState {
  connection: ConnectionState;
  snapshot: LobbySnapshot | null;
}

type Listener = (state: Readonly<AppState>) => void;

export class Store {
  private state: AppState = { connection: 'disabled', snapshot: null };
  private listeners = new Set<Listener>();

  get(): Readonly<AppState> {
    return this.state;
  }

  set(patch: Partial<AppState>): void {
    this.state = { ...this.state, ...patch };
    for (const listener of this.listeners) listener(this.state);
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    listener(this.state);
    return () => this.listeners.delete(listener);
  }
}
